import { Input, InputProps } from 'antd';
import * as React from 'react';
import { useCallback } from 'react';
import { useInputController } from '../hooks/useInputController';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility';
import { useFormItemEnabled } from '../item/useFormItemEnabled';

export interface IPasswordInputProps
  extends Omit<InputProps, 'name' | 'onChange'> {
  name: string;
  onChange?: (value: string | null | undefined) => void;
}

export function PasswordInput(props: IPasswordInputProps) {
  const { name, onChange: onAfterChange, ...inputProps } = props;

  const { enabled, layoutEnabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e);
      if (onAfterChange) {
        onAfterChange(e.target.value);
      }
    },
    [onChange, onAfterChange],
  );

  const accessibility = useFormItemAccessibility();

  return (
    <Input.Password
      suffix={<span aria-hidden="true" />} // See https://ant.design/components/input#why-input-lose-focus-when-change-prefixsuffixshowcount
      size="large"
      disabled={enabled === false || layoutEnabled === false}
      {...accessibility.attributes}
      {...inputProps}
      value={inputProps.value ?? value}
      ref={ref}
      onChange={handleChange}
      onBlur={onBlur}
      name={name}
    />
  );
}
